import { render, staticRenderFns } from "./OrganizeEventType.vue?vue&type=template&id=376b1bc1&scoped=true&"
import script from "./OrganizeEventType.vue?vue&type=script&lang=js&"
export * from "./OrganizeEventType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376b1bc1",
  null
  
)

export default component.exports